/**
 * ExportActions — buttons to export the dashboard as PDF or copy the share link.
 * Share link is protected by the secret from the client config.
 */

import { useState } from "react";
import { Download, Link2, Check, Lock } from "lucide-react";

interface ExportActionsProps {
  clientName: string;
  shareSecret: string;
}

export function ExportActions({ clientName, shareSecret }: ExportActionsProps) {
  const [linkCopied, setLinkCopied] = useState(false);

  /** Export PDF (Phase 3 — currently shows placeholder). */
  function handleExportPdf() {
    alert(
      `PDF export for "${clientName}" will be available in Phase 3.`
    );
  }

  /** Copy the current page URL with the secret as a query param. */
  function handleCopyLink() {
    const url = `${window.location.origin}?secret=${encodeURIComponent(shareSecret)}`;
    navigator.clipboard.writeText(url).then(() => {
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    });
  }

  return (
    <div className="flex items-center gap-3">
      <button
        onClick={handleCopyLink}
        className="mck-btn-secondary inline-flex items-center gap-2 text-sm"
      >
        {linkCopied ? (
          <>
            <Check size={14} className="text-green-600" />
            Copied
          </>
        ) : (
          <>
            <Link2 size={14} />
            Share link
          </>
        )}
      </button>

      <button
        onClick={handleExportPdf}
        className="mck-btn-secondary inline-flex items-center gap-2 text-sm"
      >
        <Download size={14} />
        Export PDF
      </button>

      <span className="inline-flex items-center gap-1 text-xs text-text-muted">
        <Lock size={10} />
        Secret-protected
      </span>
    </div>
  );
}
